import { Injectable } from '@angular/core';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { RestApi } from '../../auth/rest.api';
import { AuthenticationFlow } from '../auth-code-grant/core/enums';
//import {MessageService} from './message.service';

@Injectable({
  providedIn: 'root'
})
export class SapServices {

  private mcwUrl = "api/ExternalSystem/SAPCP";

  constructor(private _restApi: RestApi, /*private messageService: MessageService*/) {
  }

  updateConfiguartion(sapConfiguartion: ISAPConfiguration, sapGuid: string): Observable<any> {
    return this._restApi.post(this.mcwUrl + '/' + sapGuid, sapConfiguartion)
      .pipe(
        catchError(this.handleError<any>('updateConfiguration', { success: 'false' }))
      );
  }

  getAllDestinations(url, accessToken): Observable<ISAPDestination[]> {
    const body = {accessToken};
    return this._restApi.post(this.mcwUrl + '/destinations/' + url, body)
      .pipe(catchError(this.handleError<ISAPDestination[]>('destinations', null))
      );
  }

  getSAPConfiguration(sapGuid: string): Observable<any> {
    return this._restApi.get(this.mcwUrl + '/' + sapGuid)
      .pipe(
        catchError(this.handleError<ISAPConfiguration>('sapconfiguration', null))
      );
  }

  getSAPConfigurations(): Observable<any> {
    return this._restApi.get(this.mcwUrl)
      .pipe(
        catchError(this.handleError<ISAPConfiguration[]>('getSAPConfigurations', null))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      //console.error(error); // log to console instead
      // this.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      //this.messageService.showError(error.message)
      return of(result as T);
    };
  }

  private log(message: string) {
    // this.messageService.add(`SapService: ${message}`);
  }
}
